import { getIsListOpen } from '../utils';
const isClickEvent = (e) => 'detail' in e && e.detail !== 0; // detail === 0 indicates enter press
const handleChildClick = ({ name, selectedValue, setIsEnterPress, setIsEscOrTabPress, setOn, setOff }) => (e) => {
    if (!isClickEvent(e))
        return;
    const target = e.target;
    const targetId = target && target.id;
    const detailsHasOpen = getIsListOpen(name);
    // no targetId means that the placeholder Option was clicked
    if (targetId === '') {
        // details toggle event does not cause rerender, so here we're
        // syncing isToggled with its state
        if (detailsHasOpen) {
            setOff();
            setIsEnterPress(false);
        }
        else {
            setOn();
            // toggling the list with mouse click should do the same as using the Enter key
            setIsEnterPress(true);
        }
    }
    else {
        // if a child was clicked, new selection has been made, so
        // the list needs to be closed
        setOff();
        setIsEnterPress(false);
        // clicking the already selected option should do the same as using the Esc/Tab key
        if (targetId === selectedValue) {
            setIsEscOrTabPress(true);
        }
    }
};
export default handleChildClick;
//# sourceMappingURL=handleChildClick.js.map